import { render, staticRenderFns } from "./change-phone.vue?vue&type=template&id=5b736d23"
import script from "./change-phone.vue?vue&type=script&lang=js"
export * from "./change-phone.vue?vue&type=script&lang=js"
import style0 from "./change-phone.vue?vue&type=style&index=0&id=5b736d23&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports